import { apiGet } from 'portal.common/api/default'
import { PortalBaseUrl } from 'portal.common/js/portalBaseUrl.js'

const base = '';

/**
 * IRA rest api for Portal: https://prod.ibkr-web.com/ibconfluence/display/CASHIER/IRA+REST+Service+for+Portal
 */

function getIRAContributions(acctId) {
    return apiGet(base + '/ira/isa-contributions/' + acctId);
}

export default {
    getIRAContributions,
}
